<template>
  <v-app>
    <nt-navBar
      :serviceOptions="serviceOptions"
      :drawer="drawer"
      :appLogo="appCatalogLogo"
      @goToMainScreen="showMainScreen"
      @openDrawer="drawer = true"
      @closeDrawer="drawer = false"
      @logOut="onLogOut"
      @signIn="onSignIn"
      @submitFeedback="feedbackDialog = true"
      :showSignIn="false"
    ></nt-navBar>
        <router-view />
        <v-footer color="rgba(250,250,250,1)" class="pt-0">
      <v-container class="pt-0">
        <v-row>
          <v-col sm="6" md="9" cols="12" class="d-flex flex-column justify-start align-start">
            <v-img
              src="@/assets/NEXTnet_logo.svg"
              alt=""
              width="20"
              height="20"
              contain
              class="flex-shrink-0 flex-grow-0 ma-0 mb-2"
            />
            <p class="body-small text-secondary ma-0 text-left flex-shrink-0 flex-grow-0">
              NEXTnet, LLC &copy; {{ new Date().getFullYear() }}
            </p>
          </v-col>
          <!-- <v-col sd="6" md="3" cols="12" class="d-flex flex-column" v-if="userInfo">
            <p class="caption text-secondary ma-0 text-left flex-shrink-0 flex-grow-0 font-weight-bold">
              Customer support
            </p>
            <p class="caption text-secondary ma-0 text-left flex-shrink-0 flex-grow-0">
              <a href="mailto:avsupport@avionica.com">avsupport@avionica.com</a>
            </p>
            <p class="caption text-secondary ma-0 text-left flex-shrink-0 flex-grow-0">
              +1 (786) 544 1141
            </p>
          </v-col> -->
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import userMixin from "./mixins/userMixin";

export default {
  name: "App",

  data: () => ({
    drawer: false,
    feedbackDialog: false,
    appCatalogLogo: require("@/assets/appCatalog.png")
  }),
  mixins: [userMixin],
  // async created() {
  //   this.getCurrentUser();
  // },
  methods: {
    example() {
      console.log("main");
    },
    onSignIn() {
      window.location.assign("/login");
    },
    onSubmitFeedback() {
      window.open("mailto:feedback@nextnet.aero?subject=Feedback");
    },
    onLogOut() {
      window.location.assign("/logout");
    },
    showMainScreen() {
      if (this.$route.name !== 'appsListing') {
        this.$router.push({ name: 'appsListing' });
      } else {
        this.$router.go();
      }
    },
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser.data,
      serviceOptions: (state) => state.currentUser.serviceOptions,
    }),
  },
  watch: {
    currentUser() {
      let availableServices = [];

      availableServices = this.currentUser.services
        .filter((service) => service.roleName !== "No Access")
        .map(function(service) {
          return {
            title: service.name,
            link: service.url,
            image: service.iconUrl,
          };
        });
      this.$store.commit("currentUser/setServiceOptionState", availableServices);
    },
  }
};
</script>
<style>
.border-top-footer {
  border-top: 1px solid #EEEEEE;
}
</style>